let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eurNM")).then(() => parcelRequire('ee1yi'));